module.exports = __webpack_public_path__ + "static/media/exact-poland.6e47eb25.png";